import { cn } from "@/shared/utils";
import { Slot } from "@radix-ui/react-slot";
import { cva, VariantProps } from "class-variance-authority";
import { ComponentProps, PropsWithChildren } from "react";

const cardVariants = cva("flex shrink-0 min-w-[208px] max-w-[208px] min-h-[82px] max-h-[82px] flex-col border", {
    variants: {
        variant: {
            sein: "border-default rounded-m border gap-0.5",
            "sein-selected": "rounded-m bg-selected-default gap-0.5",
            spoorweb: "bg-default border-accent-pink-default rounded-l border-2 pr-1.5 pl-3 pt-1.5 pb-2 gap-1.5",
        },
    },
    defaultVariants: {
        variant: "sein",
    },
});

type CardProps = VariantProps<typeof cardVariants> &
    ComponentProps<"li"> & {
        className?: string;
        asChild?: boolean;
        element?: string;
    };

export function Card({ variant, className, children, asChild, element = "li", ...props }: PropsWithChildren<CardProps>) {
    const Component = asChild ? Slot : element;
    return (
        <Component className={cn(cardVariants({ variant }), className)} {...props}>
            {children}
        </Component>
    );
}
